<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <div class="card">
              <Alert :text="$t('pacto_legal_module_validation_required')" type="danger" dismissable="false"
                v-if="requiredError" />
              <Alert :text="apiErrorText" type="danger" dismissable="false" v-if="apiError" />
              <div class="card-header headerDiv">
              </div>
              <div class="card-content divHeading">
                <h5 class=" headStyle headerStyle"> {{ $t('pacto_leagal_module_heading_privacy_policy') }} </h5>
                <form action="">
                  <div class="col-md-12 formDiv">
                    <div class="form-group row">
                      <div class="col-md-6 col-sm-12">
                        <label for="org-name" class="termDescriptionInput">{{
                            $t('pacto_leagal_module_label_privacy_policy_link')
                        }}</label>
                        <input type="text" class="form-control privacyPolicyInput" v-model="privacyPolicyLink"
                          :placeholder="$t('pacto_leagal_module_placeholder_privacy_policy_link')"
                          :class="privacyPolicyError ? 'form-control privacyPolicyInput errorValidation' : 'form-control privacyPolicyInput'" />
                      </div>


                      <div class="col-md-6 col-sm-12">
                        <label for="org-name" class="termDescriptionInput">{{
                            $t('pacto_leagal_module_label_privacy_policy_full_link')
                        }}</label>
                        <input type="text" class="form-control privacyPolicyInput" v-model="privacyPolicyFullLink"
                          :class="privacyPolicyFullLinkError ? 'form-control privacyPolicyInput errorValidation' : 'form-control privacyPolicyInput'"
                          :placeholder="$t('pacto_leagal_module_placeholder_privacy_policy_full_link')" />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 simplifiedFormDiv">
                    <h5 class="headStyle"> {{ $t('pacto_leagal_module_heading_privacy_policy_simplified') }} </h5>
                    <div class="simplifiedDivStyle col-md-12">
                      <div class="form-group row simplifiedRowStyle">
                        <div class="col-md-6 ">
                          <div class="col-md-12 simplifiedSecondDiv spacingSecondDiv" >
                            <button type="button" class="btn  buttonStyle ml-1" @click="buttonClick('English')"
                              :class="englishTerms ? 'btn-primary' : 'btn-light-secondary '">
                              <em class="bx bx-check d-block d-sm-none"></em>
                              <span class="fontStyle">{{ $t('pacto_legal_english_language') }}</span>
                            </button>
                          </div>
                          <div class="col-md-12" v-if="englishTerms">
                            <div class="col-md-12 " v-for="(lan,index) in englishTermsArray" :key="index">
                              <img v-if="englishTermsArray.length > 1" src="@/assets/trash.svg" alt="error" class="trashStyle" @click="deleteImage(index)" />
                              <label for="org-name" class="termDescriptionInput">{{
                                  $t('pacto_legal_label_term_title_english')
                              }}</label>
                              <input type="text" class="form-control termTitleInputStyle" v-model="lan.title" />
                              <label for="org-name" class="termDescriptionInput">{{
                                  $t('pacto_legal_term_description_english_language')
                              }}</label>
                              <textarea name="" id="" class="form-control textareaStyle" cols="30" rows="7"
                                v-model="lan.description"></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 simplifiedSecondDiv">
                          <div class="col-md-12 simplifiedSecondDiv spacingSecondDiv" >

                            <button type="button" class="btn  buttonStyle ml-1" @click="buttonClick('Polish')"
                              :class="polishTerms ? 'btn-primary' : 'btn-light-secondary '">
                              <em class="bx bx-check d-block d-sm-none"></em>
                              <span class="fontStyle">{{ $t('pacto_legal_polish_language') }}</span>
                            </button>
                            <button type="button" class="btn  buttonStyle ml-1" @click="buttonClick('Arabic')"
                              :class="arabicTerms ? 'btn-primary' : 'btn-light-secondary '">
                              <em class="bx bx-check d-block d-sm-none"></em>
                              <span class="fontStyle">{{ $t('pacto_legal_arabic_language') }}</span>
                            </button>
                            <button type="button" class="btn  buttonStyle ml-1" @click="buttonClick('French')"
                              :class="frenchTerms ? 'btn-primary' : 'btn-light-secondary '">
                              <em class="bx bx-check d-block d-sm-none"></em>
                              <span class="fontStyle">{{ $t('pacto_legal_french_language') }}</span>
                            </button>

                          </div>
                          <div>
                            <div class="col-md-12 " v-if="polishTerms">
                              <div class="col-md-12 " v-for="(polishlan,index) in polishTermsArray" :key="index">
                                <img v-if="polishTermsArray.length > 1" src="@/assets/trash.svg" alt="error" class="trashStyle" @click="deleteImage(index)" />
                                <label for="org-name" class="termDescriptionInput">{{
                                    $t('pacto_legal_label_term_title_polish')
                                }}</label>
                                <input type="text" class="form-control termTitleInputStyle" v-model="polishlan.title" />
                                <label for="org-name" class="termDescriptionInput">{{
                                    $t('pacto_legal_term_description_polish_language')
                                }}</label>
                                <textarea name="" id="" class="form-control textareaStyle" cols="30" rows="7"
                                  v-model="polishlan.description"></textarea>
                              </div>
                            </div>
                            <div class="col-md-12 " v-if="arabicTerms">
                              <div class="col-md-12 " v-for="(arabiclan,index) in arabicTermsArray" :key="index">
                                <img v-if="arabicTermsArray.length > 1" src="@/assets/trash.svg" alt="error" class="trashStyle" @click="deleteImage(index)" />
                                <label for="org-name" class="termDescriptionInput">{{
                                    $t('pacto_legal_label_term_title_arabic')
                                }}</label>
                                <input type="text" class="form-control termTitleInputStyle text-right" v-model="arabiclan.title" />
                                <label for="org-name" class="termDescriptionInput">{{
                                    $t('pacto_legal_term_description_arabic_language')
                                }}</label>
                                <textarea name="" id="" class="form-control textareaStyle text-right" cols="30" rows="7"
                                  v-model="arabiclan.description"></textarea>
                              </div>
                            </div>
                            <div class="col-md-12 " v-if="frenchTerms">
                              <div class="col-md-12 " v-for="(frenchlan,index) in frenchTermsArray" :key="index">
                                <img v-if="frenchTermsArray.length > 1" src="@/assets/trash.svg" alt="error" class="trashStyle" @click="deleteImage(index)" />
                                <label for="org-name" class="termDescriptionInput">{{
                                    $t('pacto_legal_label_term_title_french')
                                }}</label>
                                <input type="text" class="form-control termTitleInputStyle" v-model="frenchlan.title" />
                                <label for="org-name" class="termDescriptionInput">{{
                                    $t('pacto_legal_term_description_french_language')
                                }}</label>
                                <textarea name="" id="" class="form-control textareaStyle" cols="30" rows="7"
                                  v-model="frenchlan.description"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                    </div>

                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-light-secondary ml-1 buttonSavingStyle" @click="cancelPactoData()">
                  <em class="bx bx-check d-block d-sm-none"></em>
                  <span class="d-none d-sm-block">{{ $t('pacto_settings_module_gdpr_requests_cancel_button') }}</span>
                </button>
                <button type="button" class="btn btn-primary ml-1 buttonSavingStyle" @click="saveData()">
                  <em class="bx bx-check d-block d-sm-none"></em>
                  <span class="d-none d-sm-block">{{ $t('pacto_legal_button_save_term') }}</span>
                </button>
                <button type="button" class="btn btn-primary ml-1 buttonSaveStyle" @click="addTerm()">
                  <em class="bx bx-check d-block d-sm-none"></em>                  
                  <span class="d-none d-sm-block">{{ $t('pacto_legal_button_add_term') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade text-left" id="edit-confirm-modal" tabindex="-1" role="dialog"
      aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content resetPasswordDialogue">
          <div class="modal-header">
            <h3 class="modal-title resetPasswordHeading" id="create-modal-title">{{
                $t('pacto_settings_module_edit_confirm_heading')
            }}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
              <img :src="closeImage" :alt="$t('error_message_for_loading_image')">
            </button>
          </div>
          <div class="modal-body">

            <h3 class="modal-title resetPasswordSuccessHeading" id="create-modal-title">
              {{ $t('pacto_settings_module_edit_confirm_message') }}</h3>
          </div>
          <div class="modal-footer modalFooter">


            <button type="button" class="btn btn-primary ml-1" data-dismiss="modal" aria-label="Close">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{
                  $t('pacto_settings_module_edit_confirm_ok_button')
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from "@/components/Alerts";
import { v4 as generate_UUID } from 'uuid';
export default {
  name: "PactoLegalPage",
  components: {
    Alert
  },
  props: ['orgId'],
  data() {
    return {
      privacyPolicyLink: '',
      privacyPolicyFullLink: '',
      language: 'default',
      englishTerms: true,
      polishTerms: true,
      arabicTerms: false,
      frenchTerms: false,
      englishTermTitle: '',
      englishTermDescription: '',
      polishTermTitle: '',
      polishTermDescription: '',
      arabicTermTitle: '',
      arabicTermDescription: '',
      frenchTermTitle: '',
      frenchTermDescription: '',
      organisationSettings: [],
      // terms:[ar[{title: '', description:''}] ,en[{title: '', description:''}],po[{title: '', description:''}], fr[{title: '', description:''}]],
      orgId: this.orgId,
      englishTermsArray: [{ title: '', description: '' }],
      polishTermsArray: [{ title: '', description: '' }],
      arabicTermsArray: [{ title: '', description: '' }],
      frenchTermsArray: [{ title: '', description: '' }],
      requiredError: false,
      privacyPolicyError: false,
      privacyPolicyFullLinkError: false,
      data: {},
      apiError: false,
      apiErrorText: '',
      closeImage: require('@/assets/close.png').default,

    }
  },
  methods: {

    cancelPactoData(){
      this.privacyPolicyLink = '';
      this.privacyPolicyFullLink = '';
      this.englishTermTitle= '';
      this.englishTermDescription= '';
      this.polishTermTitle ='';
      this.polishTermDescription= '';
      this.arabicTermTitle= '';
      this.arabicTermDescription='';
      this.frenchTermTitle='';
      this.frenchTermDescription= '';
      this.getPactoData() 
      this.buttonClick('Polish')
    },
    buttonClick(lang) {
      let self = this;

      if (lang == 'Polish') {
        self.polishTerms = true;
        self.arabicTerms = false;
        self.frenchTerms = false
      }
      if (lang == 'Arabic') {
        self.polishTerms = false;
        self.arabicTerms = true;
        self.frenchTerms = false
      }
      if (lang == 'French') {
        self.polishTerms = false;
        self.arabicTerms = false;
        self.frenchTerms = true;
      }

    },
    alphaOnly(event) {
      console.log("keypresssssssss");
      let key = event.keyCode;
      console.log("key", key);
      return ((key >= 65 && key <= 90) || key == 8);
    },
   
    getPactoData() {
      let self = this;
      this.$apiCall.get(`v1/clo-organization/${self.orgId}/settings`).then((response) => {
        self.organisationSettings = response.data.organizationSetting;
        self.privacyPolicyLink = self.organisationSettings.linkPrivacyPolicyWebsite
        self.privacyPolicyFullLink = self.organisationSettings.linkTermsWebsite
        self.terms = self.organisationSettings.terms;
        self.englishTermsArray = self.terms.en
        self.polishTermsArray = self.terms.po
        self.arabicTermsArray = self.terms.ar
        self.frenchTermsArray = self.terms.fr
      });

    },
    addTerm() {      
        this.englishTermsArray.push({ title: '', description: '', id:generate_UUID() })
        this.polishTermsArray.push({ title: '', description: '', id:generate_UUID()  })
        this.arabicTermsArray.push({ title: '', description: '', id:generate_UUID()  })
        this.frenchTermsArray.push({ title: '', description: '', id:generate_UUID()  })
    },
    deleteImage(deleteIndex){
       this.englishTermsArray.splice(deleteIndex, 1);
       this.polishTermsArray.splice(deleteIndex, 1);
       this.arabicTermsArray.splice(deleteIndex, 1);
       this.frenchTermsArray.splice(deleteIndex, 1);
    },
    saveData() {
      let self = this;
      self.requiredError = false;
      self.privacyPolicyError = false;
      self.privacyPolicyFullLinkError = false;

      if (self.privacyPolicyLink) {
        self.requiredError = false;
      } else {
        self.requiredError = true;
        self.privacyPolicyError = true;
      }

      if (self.privacyPolicyFullLink) {
        self.requiredError = false;
      } else {
        self.requiredError = true;
        self.privacyPolicyFullLinkError = true;
      }
      if (!self.requiredError && !self.privacyPolicyError && !self.privacyPolicyFullLinkError) {
        self.data = {
            linkPrivacyPolicyWebsite: self.privacyPolicyLink,
            linkTermsWebsite: self.privacyPolicyFullLink,
            terms: {
              en: self.englishTermsArray,
              po: self.polishTermsArray,
              ar: self.arabicTermsArray,
              fr: self.frenchTermsArray
            }
          
        }
        this.$apiCall.patch(`v1/clo-organization/${self.orgId}/settings`, self.data).then((response) => {
          $("#edit-confirm-modal").modal();

        }).catch((error) => {
          self.apiError = true;
          self.apiErrorText = `<strong>Ops!</strong> ${error.response.data.message}`;
        })
      }
    }

  },
  mounted() {
    this.getPactoData()
  }
}
</script>


<style scoped>
.headerDiv {
  border-top: 1px solid rgba(189, 190, 190, 0.5);
  ;
}

.headStyle {
  font-weight: 500;
  font-size: 16px;
  color: #475F7B;

}
.headerStyle{
  margin-left: 12px;
}

.divHeading {
  padding-left: 1em;
}

.formDiv {
  padding-top: 1em;
}

.privacyPolicyInput {
  height: 75%;
  width: 94%;
}

.termTitleInput {
  height: 75%;
  width: 94%;
  margin-top: 1em;
}
.spacingSecondDiv{
  margin-left: -2em;
}

.simplifiedFormDiv {
  padding-top: 3em;
  ;
}

.postalCodeBillingLabel {
  color: #b8b8b8;
}

.termDescriptionInput {
  color: #4A4949;
    font-size: 16px;
    font-weight: 400;
  margin-top: 1em;
}

.simplifiedDivStyle {
  border: 1px solid #F2F4F4;
  width: 97%;
}

.simplifiedSecondDiv {
  width: 100%;
  /* background-color: #F2F4F4; */
  padding-bottom: 2em
}

.buttonStyle {
  height: 3em;
  border-radius: 6px;
  margin-top: 2.5em;
  transform: translate(25px, 0px);
  width: 7em;
}

.btn-light-secondary-font {
  font-size: 14px;
  color: black !important;
  font-weight: 400;
}
.trashStyle{
    width: 20px;
    float: right;   
    transform: translate(-37px, 10px);
    cursor: pointer;
}

.btn-light-secondary {
  color: #546E7A
}

.fontStyle {
  color: white;
}

.termTitleInputStyle {
  height: 15%;
  width: 95%;
  margin-top: 1em;
}

.simplifiedRowStyle {
  height: 100%;
}

.textareaStyle {
  width: 95%;
  margin-top: 1em;
}

.buttonSaveStyle {
  margin-right: 1.5em;
  width: 12em;
}

.buttonSavingStyle {
  margin-right: 1.5em;
  width: 7em;
}

.errorValidation {
  border: 1px solid red;
}

@media (max-width: 1366px) {
  .buttonStyle {
    width: 6em;
    transform: translate(-8px, 0px);

  }
  .spacingSecondDiv{
    margin-left: 0em;
  }

  .buttonSaveStyle {
    margin-right: .5em;

  }
  .fontStyle{
    font-size: 13px;
    color: white;
  }
}
</style>
